import React, { useEffect, useRef, useState } from "react";
import DateHeader from "./DateHeader";
import { formatTimeToDate } from "../general/formateDate";

const ChatMessages = ({
  variant = "full", // 'full' pour la première variante, 'small' pour la deuxième
  groupedMessages = [],
  filteredMessages = [],
  currentUser,
}) => {
  const chatBoxRef = useRef(null);
  const observerRef = useRef([]);
  const [visibleIndex, setVisibleIndex] = useState(0);

  const scrollToBottom = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [filteredMessages, groupedMessages]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = observerRef.current.indexOf(entry.target);
            setVisibleIndex(index);
          }
        });
      },
      { threshold: 1.0 }
    );

    // Vérifie les éléments avant de les observer
    observerRef.current.forEach((el) => {
      if (el instanceof Element) {
        // Assure-toi que el est un élément DOM
        observer.observe(el);
      } else {
        console.warn("Element is not a DOM object:", el);
      }
    });

    return () => observer.disconnect();
  }, [groupedMessages]);

  return (
    <>
      {variant === "full" ? (
        <div className="chatBoxMessage" ref={chatBoxRef}>
          {groupedMessages.map((group, index) => (
            <div
              key={index}
              ref={(el) => (observerRef.current[index] = el)}
              className="dateContainer"
            >
              {group.length > 0 && (
                <DateHeader
                  date={formatTimeToDate(
                    group[0]?.MessageDate || null,
                    "small"
                  )}
                  isVisible={index >= visibleIndex}
                />
              )}
              {group.map((msg, idx) => (
                <div
                  key={idx}
                  style={{
                    textAlign:
                      msg.Sender_Person.ID === currentUser?.Person?.Person_ID
                        ? "right"
                        : "left",
                  }}
                >
                  <div
                    className={
                      msg.Sender_Person.ID === currentUser?.Person?.Person_ID
                        ? "chatMessageOwner"
                        : "chatMessageNotOwner"
                    }
                  >
                    <small>{formatTimeToDate(msg.MessageDate, "time")} :</small>{" "}
                    <strong>{msg.Text}</strong>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        filteredMessages.length > 0 && (
          <div className="chatBoxMessage chatBoxMessageSmall" ref={chatBoxRef}>
            {filteredMessages.slice(-4).map((msg, index) => (
              <div
                key={index}
                style={{
                  textAlign:
                    msg.Sender_Person.ID === currentUser?.Person?.Person_ID
                      ? "right"
                      : "left",
                }}
              >
                <div
                  className={
                    msg.Sender_Person.ID === currentUser?.Person?.Person_ID
                      ? "chatMessageOwner"
                      : "chatMessageNotOwner"
                  }
                >
                  <small>{formatTimeToDate(msg.MessageDate)} :</small>{" "}
                  <strong>{msg.Text}</strong>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </>
  );
};

export default ChatMessages;
